export type ConcurrencyResult<TResult> =
  | { status: "fulfilled"; value: TResult }
  | { status: "rejected"; reason: unknown }

export const mapWithConcurrency = async <TItem, TResult>(
  items: TItem[],
  limit: number,
  mapItem: (item: TItem, index: number) => Promise<TResult>
): Promise<ConcurrencyResult<TResult>[]> => {
  const results: ConcurrencyResult<TResult>[] = new Array(items.length)
  let nextIndex = 0

  const runWorker = async (): Promise<void> => {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex++
      try {
        results[currentIndex] = { status: "fulfilled", value: await mapItem(items[currentIndex], currentIndex) }
      } catch (reason) {
        results[currentIndex] = { status: "rejected", reason }
      }
    }
  }

  const workers = Array.from({ length: Math.min(limit, items.length) }, runWorker)
  await Promise.all(workers)

  return results
}
